<a
	[href]="whatsAppContactUrl"
	class="whatsapp-contact flex"
	target="_blank"
	rel="noopener noreferrer"
	(click)="onWhatsAppClick()"
>
	<img src="assets/images/ico-whatsapp.svg" alt="WhatsApp icon" class="whatsapp-icon" />
	<p class="contact-text text">Contacta <b>un ejecutivo y hazte cliente</b></p>
</a>
